var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultTheme } from '@daisy/themes';
import React from 'react';
import { ThemeProvider } from 'styled-components';
export var ComponentLibraryThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    var componentLibraryTheme = {
        componentTheme: __assign(__assign({}, defaultTheme), theme)
    };
    return React.createElement(ThemeProvider, { theme: componentLibraryTheme.componentTheme }, children);
};
export default ComponentLibraryThemeProvider;
